import { CifaStatusEnum, StatusCifaTextEnum } from 'enum/cifaStatus.enum';

export const getStatusText = (status: CifaStatusEnum) => {
  switch (status) {
    case CifaStatusEnum.NOT_STARTED:
      return StatusCifaTextEnum.NOT_STARTED;
    case CifaStatusEnum.PENDING:
      return StatusCifaTextEnum.PENDING;
    case CifaStatusEnum.WAITING_FOR_APPROVAL:
      return StatusCifaTextEnum.WAITING_FOR_APPROVAL;
    case CifaStatusEnum.APPROVED:
      return StatusCifaTextEnum.APPROVED;
    case CifaStatusEnum.REJECTED:
      return StatusCifaTextEnum.REJECTED;
    default:
      return StatusCifaTextEnum.NOT_STARTED;
  }
};

export const validateAllPending = (cifa: any): boolean => {
  if (!cifa) return false;
  return (
    cifa.status_aba_1 === CifaStatusEnum.PENDING &&
    cifa.status_aba_2 === CifaStatusEnum.PENDING &&
    cifa.status_aba_3 === CifaStatusEnum.PENDING &&
    cifa.status_aba_4 === CifaStatusEnum.PENDING
  );
};

export default {
  getStatusText,
  validateAllPending,
};
